import React from 'react';
import { CoverImage } from '@dynamic-flow/ui';
import MarkdownRenderer from './MarkdownRenderer';

interface PageContentProps {
  label: string;
  description?: string;
  coverImageUrl?: string;
  markdownContent?: string;
  variables?: Record<string, string>;
  fallback?: React.ReactNode;
}

export function PageContent({
  label,
  description,
  coverImageUrl,
  markdownContent,
  variables,
  fallback,
}: PageContentProps) {
  return (
    <>
      <h1 className="text-2xl font-bold mb-2 text-text-primary [&_*]:text-text-primary text-center">
        <MarkdownRenderer
          className="text-text-primary [&_*]:text-text-primary"
          source={label}
        />
      </h1>
      {description && <p className="mb-6 text-text-primary">{description}</p>}

      <CoverImage src={coverImageUrl} alt={label} />

      {markdownContent && (
        <MarkdownRenderer
          source={markdownContent}
          className="[&_*]:text-text-primary"
          variables={variables}
        />
      )}

      {fallback}
    </>
  );
}

export function SuccessFallback({
  message = 'Your response has been submitted successfully.',
}: {
  message?: string;
}) {
  return (
    <div className="text-center">
      <div className="success-icon-container w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          className="success-icon w-8 h-8"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>
      <p className="text-text-primary">{message}</p>
    </div>
  );
}
